import { FinCategoryID } from './finCategoriesTypes';

export class FinCategoryCache {
  static selectRootFinCategoriesFieldCacheKey() {
    return `select-root-fin-categories-field`;
  }

  static selectFieldCacheKey() {
    return `select-fin-categories-field`;
  }

  static selectFieldSubCategoriesCacheKey(parentFinCategoryId: FinCategoryID) {
    return `select-fin-sub-categories-${parentFinCategoryId}-field`;
  }
}
